module.exports = __webpack_public_path__ + "static/media/1_nature.37b63e81.jpg";